import ActionType from 'actions/ActionType'

export default (state = null, action) => {
  switch (action.type) {
    case ActionType.Tasks.SELECT_GROUP:
      return action.payload
    case ActionType.Tasks.RECEIVE_TASK:
      if (action.payload && action.groupsByID2) {
        if (
          action.payload.add_contacts_to_group &&
          action.payload.add_contacts_to_group.trigger_data &&
          action.payload.add_contacts_to_group.trigger_data.contactgroup_id
        ) {
          return action.groupsByID2[
            action.payload.add_contacts_to_group.trigger_data.contactgroup_id
          ]
        }

        if (
          action.payload.remove_contacts_from_group &&
          action.payload.remove_contacts_from_group.trigger_data &&
          action.payload.remove_contacts_from_group.trigger_data.contactgroup_id
        ) {
          return action.groupsByID2[
            action.payload.remove_contacts_from_group.trigger_data
              .contactgroup_id
          ]
        }
      }
      return null
    default:
      return state
  }
}
